import type { Expression } from "mapbox-gl";
import { LAYER_CONFIG } from "./configs";
import {
  Coordinates,
  DataLayer,
  LayerControlState,
} from "./types";

export const getLayerHeight = (layer: DataLayer): Expression => [
  "case",
  ["has", "height"],
  ["get", "height"],
  5,
];

export const getLayerBase = (layer: DataLayer): Expression => [
  "case",
  ["has", "base_height"],
  ["get", "base_height"],
  0,
];

export const createVectorTileSource = (layer: DataLayer) => ({
  type: "vector" as const,
  tiles: [
    // TODO: Update with your electricity market tile source
    `https://your-tile-source.s3.region.amazonaws.com/path/${layer.folder}/{z}/{x}/{y}.pbf`,
  ],
  minzoom: 0,
  maxzoom: 18,
});

export const createInitialControlState = (): LayerControlState => {
  return LAYER_CONFIG.reduce((acc, config) => {
    if (config.type === "checkbox" || config.type === "switch") {
      acc[config.id] = config.enabled ?? false;
    } else if (config.type === "selector") {
      acc[config.id] = config.value ?? "";
    }
    if (config.radioOptions) {
      acc[`${config.id}-radio`] =
        config.radioOptions.find((opt) => opt.selected)?.value || "default";
    }
    return acc;
  }, {} as LayerControlState);
};

// Center of Australia coordinates
export const DEMO_COORDINATES: Coordinates = {
  latitude: -25.2744,
  longitude: 133.7751,
};
